<template>
  <AuthorizationListComp></AuthorizationListComp>
</template>
<script>
import AuthorizationListComp from "../../components/Authorization/AuthorizationList.vue";

export default {
  name: "Authorizations List",
  components: { AuthorizationListComp },
  computed: {},
  mounted() {},
};
</script>
